// Minimum delay from Chatbot options (launcher_prompt_delay_seconds).
// Shared gate so neither desktop nor mobile exit-intent fires before it elapses.
(function () {
	const startTs = Date.now();
	window.__exitPopupReadyToShow = function () {
		let seconds = 0;
		try {
			seconds = Number(window.WWChatConfig.behavior.launcherPromptDelaySeconds) || 0;
		} catch (e) {}
		return (Date.now() - startTs) >= Math.max(0, seconds) * 1000;
	};
})();

(function ($) {
	// ===== Helpers (shared) =====
	const MM = window.matchMedia("(max-width: 767.98px)");
	const isMobile = () => MM.matches;
	const isThankYouView = () => {
		const params = new URLSearchParams(window.location.search);
		const thankYouParam = (params.get("thank_you") || "").toLowerCase();
		return (
			thankYouParam === "true" ||
			/(\/|^)(thank-?you|in-home-estimate-survey)(\/|$)/i.test(location.pathname)
		);
	};

	if (isThankYouView()) {
		return;
	}

	const getInlineTarget = ($el) => {
		const t = ($el.data("src") || $el.attr("href") || "").trim();
		return t && t.charAt(0) === "#" ? t : null;
	};
	const wantsStep2 = ($el) => String($el.data("step")) === "2";
	const activateStep2 = () => $("#popupForm").addClass("step-2-active");
	const resetStep = () => $("#popupForm").removeClass("step-2-active");

	// Fancybox sane defaults (one-at-a-time, no weird refocus)
	if ($.fancybox?.defaults) {
		$.fancybox.defaults.closeExisting = true;
		$.fancybox.defaults.backFocus = false;
		$.fancybox.defaults.autoFocus = false;
		$.fancybox.defaults.trapFocus = true;
	}

	// ===== Global bindings (don’t rebind inside show()) =====
	// Inline button to jump to step 2 (mobile only)
	$(document).on("click", ".step-2-trigger", function (e) {
		if (isMobile()) {
			e.preventDefault();
			activateStep2();
		}
	});

	// Reset ONLY when #popupForm actually closes
	$(document).on(
		"beforeClose.fb afterClose.fb",
		function (_e, instance, slide) {
			const src =
				(slide && slide.src) ||
				(instance && instance.current && instance.current.src) ||
				"";
			if (src === "#popupForm") resetStep();
		}
	);

	// ===== Exit Intent Controller =====
	const ExitPopup = {
		shown: false,

		init() {
			if ($("#exit-intent-popup").length) this.bindExitIntent();
			window.__showExit = () => this.show(); // manual test
		},

		isLtoPopupOpen() {
			return document.body.classList.contains("lto-popup-open");
		},

		bindExitIntent() {
			if (sessionStorage.getItem('exit_popup') === 'closed') return;
			$(document).on("mouseout.exitIntent", (e) => {
				if (this.shown) return;
				const leftDoc = !e.relatedTarget && !e.toElement;
				const topEdge = e.clientY <= 0;
				if (leftDoc && topEdge) {
					const didShow = this.show();
					// Only unbind if popup was actually shown
					if (didShow) {
						$(document).off("mouseout.exitIntent");
					}
				}
			});
		},

		show() {
			// Don't show if LTO popup is currently open
			if (this.isLtoPopupOpen()) return false;
			// Respect Chatbot options' launcher_prompt_delay_seconds as a minimum time-on-page
			if (!window.__exitPopupReadyToShow()) return false;

			this.shown = true;

			$.fancybox.open({
				src: "#exit-intent-popup",
				type: "inline",
				opts: {
					smallBtn: true,
					touch: false,
					trapFocus: true,
					autoFocus: false,

					afterShow() {
						$("#exit-intent-popup")
							.off("click.exitPopup")
							.on(
								"click.exitPopup",
								"a, [data-src]",
								function (e) {
									const $el = $(this);
									const target = getInlineTarget($el);

									if (!target) {
										$.fancybox.close(true);
										return;
									}

									e.preventDefault();

									if (target === "#popupForm") {
										if (isMobile() && wantsStep2($el))
											activateStep2();
										else resetStep();
									}

									// Close EXIT immediately, then open the target fresh
									$.fancybox.close(true);
									setTimeout(() => {
										$.fancybox.open({
											src: target,
											type: "inline",
											opts: {
												closeExisting: true,
												backFocus: false,
												autoFocus: false,
												trapFocus: true,

												// Re-assert AFTER #popupForm renders (belt-and-suspenders)
												afterShow(inst, slide) {
													if (
														slide &&
														slide.src ===
															"#popupForm" &&
														isMobile() &&
														wantsStep2($el)
													) {
														activateStep2();
													}
												},
											},
										});
									}, 0);
								}
							);
					},

					afterClose() {
						$("#exit-intent-popup").off("click.exitPopup");
						sessionStorage.setItem("exit_popup", "closed");
					},
				},
			});

			return true;
		},
	};

	$(ExitPopup.init.bind(ExitPopup));
})(jQuery);

/* ===== DROP-IN: Mobile exit-intent (scroll-up + safe fallback) =====
   - Trigger the existing exit popup on touch devices (phones/tablets)
   - Fire once when user scrolls down >200px then back up near top (<100px)
   - As a backup, fire after 20s ONLY if there’s some engagement (scrolled ≥300px or typed in a GF form)
   - Suppress while the user is actively typing in a page form (GF outside the popup)
   - Respect your existing session guard if you set sessionStorage["exit_popup"] = "closed" elsewhere
*/
(function ($) {
  const IS_TOUCH = ('ontouchstart' in window) || navigator.maxTouchPoints > 0;
  if (!IS_TOUCH) return;
  const params = new URLSearchParams(window.location.search);
  const isThankYouView =
    (params.get("thank_you") || "").toLowerCase() === "true" ||
    /(\/|^)(thank-?you|thanks|in-home-estimate-survey)(\/|$)/i.test(location.pathname);
  if (isThankYouView) return;

  const $popup = $("#exit-intent-popup");
  if (!$popup.length) return;
  if ($popup.data("popup-enabled") === false) return;

  // ===== Config =====
  const INACTIVITY_MS = 6000; // if user interacted in last N ms, suppress
  const SCROLL_DOWN_PX = 200; // "went down"
  const SCROLL_UP_TOP_PX = 100; // back near top
  const FALLBACK_MS = 20000; // backup timer

  // ===== State =====
  let shown = false;
  let scrolledDown = false;
  let lastInteractionTs = 0;
  let fallbackTimer = null;

  const now = () => Date.now();
  const eligibleSession = () => sessionStorage.getItem("exit_popup") !== "closed";
  const markInteraction = () => { lastInteractionTs = now(); };
  const recentlyEngaged = () => (now() - lastInteractionTs) < INACTIVITY_MS;

  // Primary (page) forms = GF wrappers NOT inside the popup
  const $primaryForms = $(".gform_wrapper").filter(function () {
    return $(this).closest("#exit-intent-popup").length === 0;
  });

  if ($primaryForms.length) {
    $primaryForms.on("input change focusin", "input, select, textarea", markInteraction);
  }

  // Clicking/touching outside forms ends “recent engagement” immediately
  $(document).on("mousedown touchstart", function (e) {
    if (!$(e.target).closest(".gform_wrapper").length) {
      lastInteractionTs = 0;
    }
  });

  // If a GF form submits or shows its confirmation, consider popup done for this session
  $(document).on("submit", ".gform_wrapper form", () => sessionStorage.setItem("exit_popup", "closed"));
  $(document).on("gform_confirmation_loaded", () => sessionStorage.setItem("exit_popup", "closed"));

  function shouldSuppress() {
    if (recentlyEngaged()) return true;
    const active = document.activeElement;
    const focusedInForm = active && $(active).closest(".gform_wrapper").filter(function () {
      return $(this).closest("#exit-intent-popup").length === 0;
    }).length > 0;
    return !!focusedInForm;
  }

  function showOnce(reason) {
    if (shown) return;
    if (!eligibleSession()) return;
    if (shouldSuppress()) return;
    // Don't show if LTO popup is currently open
    if (document.body.classList.contains("lto-popup-open")) return;
    // Respect Chatbot options' launcher_prompt_delay_seconds as a minimum time-on-page
    if (typeof window.__exitPopupReadyToShow === "function" && !window.__exitPopupReadyToShow()) return;

    shown = true;

    // Prefer your existing hook if present (set in your script): window.__showExit()
    if (typeof window.__showExit === "function") {
      window.__showExit();
    } else {
      // Minimal fallback (kept consistent with your Fancybox usage)
      $.fancybox.open({
        src: "#exit-intent-popup",
        type: "inline",
        opts: {
          smallBtn: true,
          touch: false,
          trapFocus: true,
          autoFocus: false,
          afterClose() {
            sessionStorage.setItem("exit_popup", "closed");
          },
        },
      });
    }

    // Cleanup listeners/timer
    $(window).off("scroll.exitpopup");
    if (fallbackTimer) clearTimeout(fallbackTimer);
  }

  // Trigger A: scroll-down then back up near top (low-noise, intent-ish)
  $(window).on("scroll.exitpopup", function () {
    if (shown) return;
    const y = window.scrollY || window.pageYOffset || 0;
    if (!scrolledDown && y > SCROLL_DOWN_PX) scrolledDown = true;
    if (scrolledDown && y < SCROLL_UP_TOP_PX) showOnce("scroll-up-near-top");
  });

  // Trigger B: fallback after 20s, but only if there’s some engagement
  fallbackTimer = setTimeout(function () {
    if (shown) return;
    const y = window.scrollY || 0;
    const engaged = y >= 300 || scrolledDown || recentlyEngaged();
    if (engaged) showOnce("fallback-timer");
  }, FALLBACK_MS);
})(jQuery);
